import { z } from 'zod';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

import { getMaxSqlTextByteLength, isMaxByteLength } from '#src/app/shared/utils/validators';

export const schema = z.object({
	ask: z.string().min(1, 'ask_required_error').max(90, 'ask_max_char_error'),
	description: z
		.string()
		.min(1, 'description_required_error')
		// checking whether the text is shorter than the 'TEXT' byte length in sql
		.refine((val) => isMaxByteLength(val, getMaxSqlTextByteLength()), {
			message: 'description_max_length_error',
		}),
});

const ERROR_MAP = new Map<string, TranslationKey>([
	['ask_required_error', translationKey('corgi.start_a_petition.edit.ask.required_error')],
	['ask_max_char_error', translationKey('corgi.start_a_petition.edit.ask.max_char_error')],
	['description_required_error', translationKey('corgi.start_a_petition.edit.description.required_error')],
	['description_max_length_error', translationKey('corgi.start_a_petition.edit.description.max_length_error')],
]);

export const getErrorMessage = (errorKey: string | undefined, t: (key: TranslationKey) => string) => {
	if (!errorKey) return null;

	const translateKey = ERROR_MAP.get(errorKey);

	if (!translateKey) return null;

	return t(translateKey);
};
